import { IDashboardAPIResponse } from "../types/dashboard.types";

export const INITIAL_DASHBOARD_STATE: IDashboardAPIResponse = {
  result: {
    totalFines: 0,
    finesByType: {
      Ticket: 0,
      Clamp: 0,
      Impound: 0,
    },
    totalCollections: 0,
    collectionsByType: {
      Clamp: 0,
      Impound: 0,
      Ticket: 0,
    },
    outstandingPayments: 0,
    outstandingByType: {
      Ticket: 0,
      Clamp: 0,
      Impound: 0,
    },
    finesTrend: [],
    collectionTrend: [],

    balanceAmount: 0,
    collectionAmount: 0,
    todayCollection: 0,
    mtdCollection: 0,
    ytdCollection: 0,
  },
  loading: false,
};
